/* esm.sh - esbuild bundle(@lit/reactive-element@1.6.3/decorators/query) esnext production */
import{decorateProperty as u}from"/v135/@lit/reactive-element@1.6.3/esnext/decorators/base.js";function s(t,l){return u({descriptor:n=>{let i={get(){var o,r;return(r=(o=this.renderRoot)===null||o===void 0?void 0:o.querySelector(t))!==null&&r!==void 0?r:null},enumerable:!0,configurable:!0};if(l){let o=typeof n=="symbol"?Symbol():"__"+n;i.get=function(){var r,e;return this[o]===void 0&&(this[o]=(e=(r=this.renderRoot)===null||r===void 0?void 0:r.querySelector(t))!==null&&e!==void 0?e:null),this[o]}}return i}})}export{s as query};
/*! Bundled license information:

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=query.js.map